module.exports = __webpack_public_path__ + "img/smart.306530ba.png";